module.exports = __webpack_public_path__ + "static/media/short-04.b57c0896.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/short/short-04.png
// module id = 2116
// module chunks = 0